<template>
  <a-card>
    <div style="float: right;">
      <div class="table-toolbar">
        <a-button type="primary" @click="onEdit">编辑
          <template #icon>
            <form-outlined />
          </template>
        </a-button>
      </div>
    </div>
    <div class="top">
      <div class="imgBox">
        <img style="width: 100%;height: 100%;"
          :src="detail.logo ? getImg(detail.logo) : '@/assets/img/defaultPhoto.png'" />
      </div>
      <div class="rightBox">
        <div class="topBox">
          <p class="name">{{ detail.name }}</p>
          <p class="nameRight">注册用户：金融机构</p>
        </div>
        <div class="second">
          <div class="name">联系人：{{ detail.contactName
          }} </div>
          <div class="name"> 联系电话：{{ detail.telephone }}</div>
        </div>
      </div>
    </div>
    <a-descriptions bordered :column="2">
      <a-descriptions-item label="姓名">{{ detail.name }}</a-descriptions-item>
      <a-descriptions-item label="机构类型">
        <dict-render :dict-obj="dictObjs['organizationType']" v-if="detail.type"
          :text="detail.type">
        </dict-render>
    </a-descriptions-item>
      <a-descriptions-item label="邮编">{{ detail.postcard }}</a-descriptions-item>

      <a-descriptions-item label="公司网址">{{detail.webSite}}</a-descriptions-item>
      <!-- <a-descriptions-item label="地区">{{ detail.city }}</a-descriptions-item> -->
      <!-- <a-descriptions-item label="详细地址">{{ detail.locationAddress }}</a-descriptions-item> -->
      <a-descriptions-item label="统一社会信用代码">{{ detail.unifiedSocialCreditCode }}</a-descriptions-item>
      <a-descriptions-item label="注册时间">{{ detail.registrationTime }}</a-descriptions-item>
      <a-descriptions-item label="法人代表">{{ detail.legalPerson }}</a-descriptions-item>
      <a-descriptions-item label="联系人">{{ detail.contactName }}</a-descriptions-item>
      <a-descriptions-item label="联系电话">{{ detail.telephone }}</a-descriptions-item>
      <a-descriptions-item label="地址" :span="2">{{ detail.provject }}{{ detail.locationAddress }}</a-descriptions-item>
      <a-descriptions-item label="机构简介"  :span="2">
        {{ detail.briefIntroduction }}
      </a-descriptions-item>
    </a-descriptions>
  </a-card>
  <InstitutionModal ref="institutionModal" :form-primary-key-field="listKeyField" @finish="getInstitutionInfo" />
</template>

<script>
import InstitutionModal from './components/InstitutionModal';
import { financeInstitution } from "@/api/finance";
import { showCity } from "@/utils/util";
import { file_service } from "@/api/adminService";
import { dictMixin } from "@/mixins";
// import { sys_policy } from "@/api/policyService";

export default {
  name: "index",
  mixins: [dictMixin],
  components: {
    InstitutionModal
  },
  data() {
    return {
      dictNames: 'organizationType',
      detail: {
        id: null,
                name: null,
                type: null,
                postcard: null,
                webSite: null,
                email: null,
                locationAddress: null,
                prov: null,
                city: null,
                dist: null,
                logo: null,
                unifiedSocialCreditCode: null,
                registrationTime: null,
                legalPerson: null,
                contactName: null,
                telephone: null,
                auditStatus: null,
                feedback: null,
                enabled: null,
                experience: null,
                successCases: null,
                views: null,
                keyWord: null,
                briefIntroduction: null,
      },
      listKeyField: "id",
    }
  },
  mounted() {
    this.getInstitutionInfo();
    // this.getTwoCode()
  },
  methods: {
    getInstitutionInfo() {
      this.getAction({
        url: financeInstitution.detail,

      }).then(res => {
        this.detail = {...res,provject: res.prov ? showCity(res.prov, res.city, res.dist) : ''}
      })
    },
    // getTwoCode() {
    //   this.getAction({
    //     url: sys_policy.getErCode
    //   }).then(res => {
    //     this.$ls.set('erweimaCode', res);
    //     // this.erweimaCode = res
    //   })
    // },
    onEdit() {
      this.onShowModal('institutionModal', this.detail);
    },
    onShowModal(refName, data = {}) {
      const refEle = this.$refs[refName];
      refEle.form = Object.assign({}, data);
      refEle.visible = true;
    },
    getImg(imgUrl) {
      return file_service.imagesWeb(imgUrl)
    },
  }
}
</script>

<style scoped lang="less">
.top {
  overflow: hidden;
  margin-bottom: 10px;

  .imgBox {
    float: left;
    margin-right: 20px;
    width: 100px;
    height: 100px;
  }

  .rightBox {
    float: left;
    color: #333;
    width: 70%;

    .topBox {
      overflow: hidden;
      padding-bottom: 10px;
      border-bottom: 1px dashed #dedede;

      .name {
        float: left;
        font-weight: 700;
        font-size: 24px;
      }

      .nameRight {
        float: left;
        margin-left: 25px;
        margin-top: 10px;
      }
    }

    .second {
      font-size: 16px;
      margin-top: 10px;
      display: flex;
      justify-content: space-around;

      .name {
        width: 50%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }
    }
  }
}
</style>
